import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/Tours/split-view-tour.png'


const _hoisted_1 = { class: "image-points" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tour_step = _resolveComponent("el-tour-step")!
  const _component_el_tour = _resolveComponent("el-tour")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.startTour,
      disabled: !_ctx.tourAvailable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('splitSegmentsTour.tourName')), 1)
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    _createVNode(_component_el_tour, {
      modelValue: _ctx.tourStart,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tourStart) = $event)),
      "target-area-clickable": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tour_step, {
          title: _ctx.$t('splitSegmentsTour.popupTitle'),
          "content-style": _ctx.stepStyle
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('splitSegmentsTour.popupDescription')), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "img-button-container merge-button" }, [
              _createElementVNode("span", { class: "material-symbols-outlined" }, " expand ")
            ], -1)),
            _createElementVNode("div", null, _toDisplayString(_ctx.hotkey), 1)
          ]),
          _: 1
        }, 8, ["title", "content-style"]),
        _createVNode(_component_el_tour_step, {
          title: _ctx.$t('splitSegmentsTour.imageStepTitle'),
          "content-style": _ctx.wideStepStyle
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "screenshot",
              src: _imports_0,
              alt: "split-view-tour.png"
            }, null, -1)),
            _createElementVNode("ol", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagePoints, (point, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(point), 1))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["title", "content-style"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}